import { combineReducers } from "redux"

// Front
import Layout from "./layout/reducer"

// Authentication
import Login from "./auth/login/reducer"
import Account from "./auth/register/reducer"
import ForgetPassword from "./auth/forgetpwd/reducer"
import Profile from "./auth/profile/reducer"

//E-commerce
import ecommerce from "./e-commerce/reducer"

//Calendar
import calendar from "./calendar/reducer"

//chat
import chat from "./chat/reducer"

//crypto
import crypto from "./crypto/reducer"

//invoices
import invoices from "./invoices/reducer"

//projects
import projects from "./projects/reducer"

//tasks
import tasks from "./tasks/reducer"

//contacts
import contacts from "./contacts/reducer"

//mails
import mails from "./mails/reducer";

//Dashboard 
import Dashboard from "./dashboard/reducer";

//Dasboard saas
import DashboardSaas from "./dashboard-saas/reducer";

//master

//holiday

import holidayReducer from "./master/holiday/reducer"

import leaveReducer from "./master/leave/reducer"

import shiftReducer from "./master/shift/reducer"

import rolesReducer from "./master/role/reducer"
import LoginCreation from "./configuration/logincreation/reducer"
import CategoryMaster from "./master/category/reducer"
import UnitMaster from "./master/unit/reducer"
import DepartmentMaster from "./master/department/reducer"
import DesignationMaster from "./master/designation/reducer"
import shiftGroupReducer from "./master/shiftgroup/reducer"
import QualificationMaster from "./master/qualification/reducer"
import EmployeeDetailsReducer from "./employee/employeedetails/reducer"
import EmployeeExemptionReducer from "./employee/exemption/reducer"
import EmployeeResignationReducer from "./employee/resignation/reducer"
import EmployeeCircularReducer from "./employee/circular/reducer"
import EmployeePermissionPolicyReducer from "./employee/permission-policy/reducer"
import EmployeeMultiLevelReducer from "./employee/multilevel-approval/reducer"
import RecruitmentKeysRespReducer from "./recruitment/keys-responsibilities/reducer"
import RecruitmentQualiReducer from "./recruitment/qualification/reducer"
import EmpGracePolicyReducer from "./employee/grace-policy/reducer"
import ReimbursementMasterReducer from "./reimbursement/master/reducer"
import ReimbursementReportsReducer from "./reimbursement/Reports/reducer"
import PayrollSetupAllowanceReducer from "./payroll/setup/allowance/reducer"
import categoryMappingReducer from "./payroll/setup/mapping/reducer"
import PayrollSetupDeductionReducer from "./payroll/setup/deduction/reducer"
import ReimbursementClaimReducer from "./reimbursement/transactions/reducer"
import PayrollSetupSalaryScaleReducer from "./payroll/setup/salary-scale/reducer"
import PayrollDeductionTaxReducer from "./payroll/deduction/tax/reducer"
import PayrollDeductionFixedDeductionReducer from "./payroll/deduction/fixed-deduction/reducer"
import JobSetupPositionSkillReducer from "./recruitment/position/reducer"
import AttendanceTimeDeductionsReducer from "./attendance/time-deductions/reducer"
import PayrollDeductionMonthlyDeductionReducer from "./payroll/deduction/monthly-deduction/reducer"
import TimesheetSetupServiceReducer from "./timesheet/setup/service/reducer"
import TimesheetSetupClientReducer from "./timesheet/setup/client/reducer"
import TimesheetSetupProjectReducer from "./timesheet/setup/project/reducer"
import TimesheetSetupModuleReducer from "./timesheet/setup/module/reducer"
import TimesheetSetupTaskReducer from "./timesheet/setup/task/reducer"
import TimesheetSetupTaskTypeReducer from "./timesheet/setup/task-type/reducer"
import PayrollSalaryEmployeeSalaryDefinitionReducer from "./payroll/salary/salary-definition/reducer"
import AttendanceBiometricReducer from "./attendance/biometric/reducer"
import PayrollSalaryExtraPaymentReducer from "./payroll/salary/extra-payment/reducer"
import PayrollSalaryAllowanceReducer from "./payroll/salary/allowance/reducer"
import PayrollSalaryStopPaymentReducer from "./payroll/salary/stoppayment/reducer"
import RecruitmentRequistionReducer from "./recruitment/requistion/reducer"
import TimesheetTransactionApplyReducer from "./timesheet/transactions/apply/reducer"
import TimesheetTransactionApprovalReducer from "./timesheet/transactions/approval/reducer"
import TimesheetReportsReducer from "./timesheet/reports/reducer"
import ExpensesMasterReducer from "./expenses/reducer"
import RecruitmentOnboardingReducer from "./recruitment/onboarding/reducer"
import AttendanceExtraDutyReducer from "./attendance/extra-duty/reducer"
import AttendanceLeaveManagReducer from "./attendance/leave/reducer"
import EmployeeReportReducer from "./report/employee/reducer"
import AttendanceReportReducer from "./report/attendance/reducer"
import SkillMasterReducer from "./master/skill/reducer"
import ResourceApprovalReducer from "./recruitment/resource-approval/reducer"
import TripmasterReducer from "./master/tripmaster/reducer"
import PayrollReportsReducer from "./payroll/reports/reducer"
import BankMasterReducer from "./master/bank/reducer"
import EvaluationMasterReducer from "./master/evaluation/reducer"
import ScoreMasterReducer from "./master/score/reducer"

const appReducer = combineReducers({
  // public
  Layout,
  Login,
  Account,
  ForgetPassword,
  Profile,
  ecommerce,
  calendar,
  chat,
  mails,
  crypto,
  invoices,
  projects,
  tasks,
  contacts,
  Dashboard,
  DashboardSaas,
  holidayReducer,
  rolesReducer,
  LoginCreation,
  CategoryMaster,
  UnitMaster,
  LoginCreation,
  leaveReducer,
  DepartmentMaster,
  DesignationMaster,
  leaveReducer,
  shiftReducer,
  shiftGroupReducer,
  QualificationMaster,
  EmployeeDetailsReducer,
  EmployeeExemptionReducer,
  EmployeeResignationReducer,
  EmployeeCircularReducer,
  EmployeePermissionPolicyReducer,
  EmployeeMultiLevelReducer,
  RecruitmentKeysRespReducer,
  RecruitmentQualiReducer,
  EmpGracePolicyReducer,
  ReimbursementMasterReducer,
  ReimbursementReportsReducer,
  PayrollSetupAllowanceReducer,
  categoryMappingReducer,
  PayrollSetupDeductionReducer,
  ReimbursementClaimReducer,
  PayrollSetupSalaryScaleReducer,
  PayrollDeductionTaxReducer,
  PayrollDeductionFixedDeductionReducer,
  JobSetupPositionSkillReducer,
  AttendanceTimeDeductionsReducer,
  PayrollDeductionMonthlyDeductionReducer,
  TimesheetSetupServiceReducer,
  TimesheetSetupClientReducer,
  TimesheetSetupProjectReducer,
  TimesheetSetupModuleReducer,
  TimesheetSetupTaskReducer,
  TimesheetSetupTaskTypeReducer,
  PayrollSalaryEmployeeSalaryDefinitionReducer,
  AttendanceBiometricReducer,
  PayrollSalaryExtraPaymentReducer,
  PayrollSalaryAllowanceReducer,
  PayrollSalaryStopPaymentReducer,
  RecruitmentRequistionReducer,
  TimesheetTransactionApplyReducer,
  TimesheetTransactionApprovalReducer,
  TimesheetReportsReducer,
  ExpensesMasterReducer,
  RecruitmentOnboardingReducer,
  AttendanceExtraDutyReducer,
  AttendanceLeaveManagReducer,
  EmployeeReportReducer,
  AttendanceReportReducer,
  SkillMasterReducer,
  ResourceApprovalReducer,
  TripmasterReducer,
  PayrollReportsReducer,
  BankMasterReducer,
  EvaluationMasterReducer,
  ScoreMasterReducer,
})

// export default rootReducer

// Root reducer wrapper
const rootReducer = (state, action) => {
  if (action.type === "RESET_ALL") {
    // ✅ this will reset ALL reducers back to their initial state
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
